const base = import.meta.env.BASE_URL || '/';

export function apiUrl(pathname) {
  return `${base}${String(pathname).replace(/^\//, '')}`;
}
